module.exports = __webpack_public_path__ + "img/GoodNatured.10e2166f.png";